export enum AppSections {
  Landing = "landing",
  Dashboard = "dashboard",
  Documents = "documents",
  Settings = "settings",
  AssetInformation = "assetInformation",
  Trends = "trends"
}